import { Dispatch } from "../../controller";
import { Model,StateProps, ModelProps } from "../../model";
import { Config, Item, MeioPag, Movimentacao, Pessoa, TabelaPrecoConfig } from "../../data.types";
import store from "../../store";
import { configController } from "./config.controll";

export type { Config } from "../../data.types"

export interface ConfigState extends StateProps<Config> {
 
}

export interface ConfigActions extends Dispatch<Config> {
    startDocConfig:()=>any
    gerarCodigoItem:(item:Item)=>any
    gerarCodigoMov:(mov:Movimentacao)=>any
}

const model = new Model<Config,ConfigState>("config");

const intialValueConfig:Config = {
    ...model.getInitialValue(),
     _id:"@CONFIG",
     _rev:undefined,
     type:"config",
     cliente_default:{} as Pessoa,
     meio_pag_default:{} as MeioPag,
     qt_dig_cod_item:3,
     qt_dig_cod_mov:4,
     seq_cod_item:0,
     seq_cod_mov:0,
     data_ini_estoque:"",
     tabela_preco_default:{} as TabelaPrecoConfig
     

}

export const initialValueState:ConfigState = {
    ...model.getInititalValueState(),
    row:intialValueConfig,
}



